import React, {useState} from "react";
import {Navigate, useNavigate} from "react-router-dom";
import styled from "styled-components/macro";
import {Link} from "react-router-dom";
import * as Yup from "yup";
import {Formik} from "formik";

import {
    Alert as MuiAlert,
    Button,
    TextField as MuiTextField,
} from "@mui/material";
import {spacing} from "@mui/system";

import {useSignInMutation} from "../../graphql/auth/auth.graphql-gen";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

function SignIn() {
    const navigate = useNavigate();
    const [loginUser] = useSignInMutation();

    const [errorMessage, setErrorMessage] = useState('');

    if (localStorage.getItem('token')) {
        return <Navigate to="/"/>
    }


    return (
        <Formik
            initialValues={{
                email: "",
                password: "",
                submit: false,
            }}
            validationSchema={Yup.object().shape({
                email: Yup.string()
                    .email("Must be a valid email")
                    .max(255)
                    .required("Email is required"),
                password: Yup.string().max(255).required("Password is required"),
            })}
            onSubmit={async (values, {setErrors, setStatus, setSubmitting}) => {
                try {
                    await loginUser({
                        variables: {
                            email: values.email,
                            password: values.password
                        },
                    }).then(res => {
                        // Store token if login is successful
                        if (res.data && res.data.signIn && res.data.signIn.accessToken && !res.data.signIn.error) {
                            window.localStorage.setItem('token', res.data.signIn.accessToken)
                            // Redirect to home page
                            navigate("/");
                        }
                        if (res.data && res.data.signIn && res.data.signIn.error) {
                            setErrorMessage(res.data.signIn.error);
                        }

                    });

                } catch (error: any) {
                    const message = error.message || "Something went wrong";
                    setStatus({success: false});
                    setErrors({submit: message});
                    setSubmitting(false);
                }
            }}
        >
            {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  touched,
                  values,
              }) => (
                <form noValidate onSubmit={handleSubmit}>

                    {errors.submit && (
                        <Alert mt={2} mb={3} severity="warning">
                            {errors.submit}
                        </Alert>
                    )}
                    {errorMessage && (
                        <Alert mt={2} mb={3} severity="warning">
                            {errorMessage}
                        </Alert>
                    )}
                    <TextField
                        type="email"
                        name="email"
                        label="Email Address"
                        value={values.email}
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        my={2}
                    />
                    <TextField
                        type="password"
                        name="password"
                        label="Password"
                        value={values.password}
                        error={Boolean(touched.password && errors.password)}
                        fullWidth
                        helperText={touched.password && errors.password}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        my={2}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                    >
                        Sign in
                    </Button>
                    <Button
                        component={Link}
                        to="/auth/forgot-password"
                        fullWidth
                        color="primary"
                    >
                        Forgot password
                    </Button>
                </form>
            )}
        </Formik>
    );
}

export default SignIn;



